import {signal} from "@preact/signals-react";

export const openLangPopover = signal(null)

export const handleLangPopoverClose = () => openLangPopover.value = null